import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentTypes } from '../../hooks';

interface ShipmentTypeSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  tooltip?: boolean;
  isDefault?: boolean;
  disableValidation?: boolean;
  onChange?: (value?: unknown) => void;
  isRequired?: boolean;
}

export const ShipmentTypeSelect: FC<ShipmentTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.shipmentType.placeholder'),
  label = i18n.t('translation:default.fields.shipmentType.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  isDefault = false,
  disableValidation = false,
  onChange,
  isRequired = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data = [], isLoading } = useGetShipmentTypes();

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={isDefault ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options] : options}
      placeholder={placeholder}
      label={label}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      tooltip={tooltip}
      disableValidation={disableValidation}
      onChange={onChange}
    />
  );
};
